__turbopack_context__.v({
  "areas": "MlaBLa_areas",
});
